/**
 * Cells carry per-plan values as a JSON-encoded string keyed by product slug:
 *   "values_per_plan": "{\"free\":\"Chat\",\"starter\":\"Chat\",\"builder\":\"Private Slack Channel\",...}"
 * This safely parses and looks up the value for the current plan.
 */
export function parseValueForSlug(
  raw: string | undefined,
  slug: string
): string | undefined {
  if (!raw) return undefined;
  try {
    const map = JSON.parse(raw) as Record<string, string>;
    return map[slug];
  } catch {
    return undefined;
  }
}
